module.exports = __webpack_public_path__ + "static/media/frizo-pro.9fb0e1d7.png";